import Vue from 'vue'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import app from './app.vue'
import router from './router'
import store from './store'
import { useI18n } from '@/i18n'
import Navigation from 'vue-navigation'
import './mock/mock'
// import echarts from 'echarts'
import 'babel-polyfill'
Vue.use(Navigation, {router, store})

// Vue.prototype.$echarts = echarts

import './style/main.less'

Vue.config.productionTip = false

Vue.use(Antd)

router.beforeEach(async (to, from, next) => {
  if (!to.meta.unauth && !store.getters.hasLogin) {
    next({ name: 'login' })
  } else {
    next()
  }
})
new Vue({
  render: h => h(app),
  i18n: useI18n(),
  router,
  store,
}).$mount('#app')
